import { saveFile } from 'data/saveFile';
import { useMutation } from 'query';
import { download } from 'scenes/FinancePage/FR/data/queryKeyFactory';
import { downloadInvoice } from 'scenes/FinancePage/FR/sources';

export const useDownloadInvoice = () => {
  const approveMutation = useMutation(download(), downloadInvoice);

  const handleAction = async ({
    id,
    fileName,
  }: {
    id: number;
    fileName: string;
  }) => {
    const fileData = await approveMutation.mutateAsync({ id });
    await saveFile({ fileData, fileName });
  };

  return [handleAction, approveMutation];
};
